<template>
    <div class="sidebar">
        <nav class="navbar navbar-expand-lg">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                <span class="navbar-toggler-icon"></span>
                <span class="navbar-toggler-icon"></span>
            </button>
           
            <div id="navbarSupportedContent" class="collapse navbar-collapse">
                <ul>
                  <li :class="{ active: currentRouteName === 'dashboard' }">
                    <a href="/dashboard" class="ic-9" v-text="translate.trans('pinker.dashBoard')"></a>
                  </li>
                  <li :class="{ active: currentRouteName === 'users-list' || isActive }">
                    <a href="/users" class="ic-9" v-text="translate.trans('pinker.userList')"></a>
                  </li>
                  <li :class="{ active: currentRouteName === 'business-users-list' || isActive }">
                    <a href="/business-users" class="ic-9" v-text="translate.trans('pinker.businessList')"></a>
                  </li>
                  <li :class="{ active: currentRouteName === 'feedbacks' || isActive }">
                    <a href="/feedbacks" class="ic-9" v-text="translate.trans('pinker.feedbacks')"></a>
                  </li>
                  <li :class="{ active: currentRouteName === 'feedback-reasons' || isActive }">
                    <a href="/feedback-reasons" class="ic-9" v-text="translate.trans('pinker.feedbackReasons')"></a>
                  </li>
                  <li :class="{ active: currentRouteName === 'message' || isActive }">
                    <a href="/message" class="ic-9" v-text="translate.trans('pinker.messages')"></a>
                  </li>
                  <li>
                    <a :href="dibbleJs.AnchorNoHandlerHref" class="ic-9" @click="logout" v-text="translate.trans('pinker.logout')"></a>
                  </li>
              </ul>
            </div>            
        </nav>
    </div>
</template>

<script>
import Vue from 'vue';
import VueRouter from 'vue-router';
import DibbleTranslation from "../../translation/translation";
import DibbleJS from "../../dibble";
Vue.use(VueRouter);

export default {
    name: 'Sidebar',
    data() {
         return {
             isActive: false,
             isParameterMenuActive: false,
             translate: DibbleTranslation,
             dibbleJs: DibbleJS
        }
    },
    computed: {
        currentRouteName() {
        
            return this.$route.name;
        }
},
    methods:{
        showSub(){
            this.isActive = !this.isActive;
        },
        showParameterSub() {
            this.isParameterMenuActive = !this.isParameterMenuActive;
        },
        logout() {
            DibbleJS.confirmBox(this.translate.trans('pinker.logoutConfirm'), this.performSystemLogout)
        },
         performSystemLogout() {
            DibbleJS.cookieDestroy();
            this.$router.push('/login');
        },
    }
}
</script>
